import axios from "axios";

const API_URL = process.env.REACT_APP_INSTAGRAM_BASE_URL;

const instagramAxiosAPI = axios.create({
  baseURL: API_URL,
});

export default instagramAxiosAPI;
